export const KEY_STORAGE_TOKEN = 'token';
export const KEY_STORAGE_TOKEN_EXP_AT = 'token_exp';
export const KEY_STORAGE_WP_TOKEN = 'auth_token';

export const KEY_STORAGE_TARGET_URL = 'target_url';
/** Блокирует запись `target_url` на ~60 с (после persist / FB / impersonate) */
export const KEY_STORAGE_TARGET_URL_LOCK_WRITE = 'target_url_lock_write';
export const KEY_GOOGLE_CLICK_ID = 'gclid';
export const KEY_REFERRAL_CODE = 'ref_code';
export const KEY_USER_UUID = 'user_uuid';
export const KEY_SESSION_UUID = 'session_uuid';
export const KEY_APPSFLYER_UID = 'appsflyer_uid';
export const KEY_APPSFLYER_SOURCE_PLATFORM = 'appsflyerSourcePlatform';
export const REGISTRATION_TYPE = 'regTypeGa';
export const SESSION_PHONE_NUMBER = 's_phn';
export const OTP_RESEND_STATE = 'otp_resend_state';
export const OTP_REMAINING_STATE = 'otp_remaining_state';
export const PTP_IGNORED_ALERT = 'ptp_alert';
export const CHANGE_PHONE_NUMBER_LIM_KEY = 'c_phn_x';
export const OTP_LIM_KEY = 'otl_x';
export const IMPERSONATE_ADMIN_ID = 'imp_admin_id';
export const CAMERA_PERMISSION_ALLOW_POPUP = 'cam_1t-per';
/** Tab session flag: admin impersonation active — do not rewrite target_url cookie */
export const SESSION_STORAGE_IMPERSONATE_ACTIVE = 'imp_sess_active';
export const VERIF_WAIT_TIME = 'verif_until';
/** Session UUID for which the create-PIN promo dialog must not be shown in personal account. */
export const PIN_DIALOG_SKIPPED_SESSION = 'pin_dialog_skipped_session';
export const AUTH_METHOD = 'auth_method'; // PinCode
/** ISO timestamp: login OTP/PIN session expires after request-otp (unauthenticated). */
export const LOGIN_OTP_SESSION_UNTIL = 'login_otp_until';
export const IMPERSONATE_COOKIE_FROM_CRM = 'impersonate'; // impersonate from CRM
export const KEY_SHA_MAIL = 'sha_mail';
export const KEY_SHA_TEL = 'sha_tel';
/** Shared with WordPress. JSON: { version, updatedAt, necessary, analytics, marketing }. path=/, 365 days, SameSite=Lax */
export const KEY_COOKIE_CONSENT = 'p365_cookie_consent';
